import { request } from '@umijs/max';

const token = '123'; // todo

/**  商机统计数据  */
export async function opportunityCount(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/count', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  确认邮件预览  */
export async function opportunityClick(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/click', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  确认邮件预览  */
export async function emailPreview(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/email/preview', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  发送合同确认邮件  */
export async function sendConfirmedContractEmail(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/send-confirmed-contract-email', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  编辑商机销售阶段描述  */
export async function bussinssDescribe(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/business-log/edit-opportunity-describe', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 编辑商机 post /installer/opportunity/edit */
export async function bussinssEdit(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/edit', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 商机跟进 post /installer/opportunity/follow-up-records */
export async function followUpRecords(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/follow-up-records', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**记录状态 post /installer/business-log */
export async function businessLog(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/business-log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**撤回商机 */
export async function rollbackBusiness(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/rollback-opportunity', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**批量撤回商机 */
export async function batchRecall(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/batch_recall', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 跟进记录 post /installer/business-log/list */
export async function businessLogList(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/business-log/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body || {},
    ...(options || {}),
  });
}

/** 商机详情 post /installer/opportunity/detail */
export async function opportunitydetail(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<OpportunitydetailRes>('/opportunity/detail', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}
/**  线索列表  */
export async function getOpportunityList1(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/list', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 商机列表 post /installer/opportunity */
export async function getOpportunityList(body: OpportunityListReq, options?: { [key: string]: any }) {
  return request<OpportunityListRes>('/opportunity/list', {
    method: 'POST',
    data: body,
    ...(options || {}),
  });
}

/** 商机转移 post */
export async function Transfer(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/transfer-opportunity', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/** 商机终止 post  */
export async function Terminate(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/terminate-opportunity', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  分配商机、重新分配商机 - 安装商列表-待开发 */
export async function getUserList(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/user/list', {
    headers: {
      // 'Content-Type': 'application/json',
      token: token,
    },
    method: 'GET',
    params: { ...options },
    ...(options || {}),
  });
}

/** 商机回访 post  */
export async function Businesslog(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/business-log', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  按照数量添加配置  */
export async function saveBatch(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/configuration/save-batch', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  4.49 添加配置信息  */
export async function configurationSave(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/configuration/save', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  4.50 修改配置信息  */
export async function configurationEdit(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/configuration/edit', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  4.51 删除配置信息  */
export async function configurationDelete(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/configuration/delete', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**撤回商机 */
export async function getphoneNumber(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/phone-number', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**上传图片 */
export async function upload(body: { [key: string]: any }, options?: { [key: string]: any }) {
  const formData = new FormData();
  // for (const key in body) {
  //   formData.append(key, body[key]);
  // }
  formData.append('id', body.id || '');
  formData.append('file', body.file || '');
  return request<RequestResponseRes>('/upload', {
    method: 'POST',
    headers: {
      // 'Content-Type': 'application/json',
      'Content-Type': 'multipart/form-data',
      token: token,
    },
    data: formData,
    ...(options || {}),
  });
}

/**撤回商机 */
export async function getfile(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/getfile', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**本地服务审核举证文件 */
export async function reviewFile(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/opportunity/review', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}

/**  4.65 查询国家列表  */
export async function systemCountry(body: { [key: string]: any }, options?: { [key: string]: any }) {
  return request<RequestResponseRes>('/system/country', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      token: token,
    },
    data: body,
    ...(options || {}),
  });
}
